import { Box, Stack, Typography } from '@mui/material';

import { _ } from '/@/locale';

const YieldEstimationGuide = () => {
    const content = [
        {
            title: _('1.    Definí los puntos de muestreo en la superficie del lote:'),
            items: [
                _('Establecé un punto cada 10-15 hectáreas por lote.'),
                _('Distribuí los puntos de manera homogénea.'),
                _('Lote irregular: Aumentá el número de muestras.'),
                _(
                    'Lote con ambientes contrastantes (suelo, relieve): Dividí en sectores y marcá los puntos para cada ambiente.'
                ),
            ],
        },
        {
            title: _('2.    Recolectá los datos en cada punto:'),
            items: [
                _('Seleccioná un surco al azar.'),
                _('Contá 21 plantas contiguas y medí la distancia entre la planta 1 y la 21 (registrá en metros).'),
                _('Retirá todas las espigas de las 21 plantas (principales y secundarias, si las hubiera).'),
            ],
        },
        {
            title: _('3. Contá las espigas por hectárea (Espigas/ha)'),
            items: [
                _('Calculá el número total de espigas (principales y secundarias).'),
                _(
                    'Utilizá la cantidad de espigas y la distancia medida para calcular el primer componente del rendimiento: Espigas/ha.'
                ),
            ],
        },
        {
            title: _('4. Analizá las espigas:'),
            items: [
                _('Clasificá las espigas principales en 3 grupos según su tamaño.'),
                _('Elegí una espiga promedio de cada grupo (7 espigas por grupo).'),
                _('Si hay espigas secundarias, seleccioná una representativa.'),
            ],
        },
        {
            title: _('5.    Calculá la cantidad de granos por espiga:'),
            items: [
                _('Para cada espiga seleccionada, contá: número de hileras y granos por hilera.'),
                _(
                    'Calculá el promedio sumando los granos de las 3 espigas principales y la secundaria (si la hubiera).'
                ),
                _('Dividí el total por 3 para obtener el segundo componente: Granos/Espiga.'),
            ],
        },
        {
            title: _('6.    El peso del grano:'),
            items: [
                _(
                    'El valor del peso es el del catálogo del híbrido. Si  o pesá 1.000 granos en balanza para calcular el P1000.'
                ),
            ],
        },
    ];

    return (
        <Stack overflow={'auto'} alignItems={'start'} textAlign={'left'} maxHeight={'75vh'}>
            <Typography color={'primary'} variant='body1' fontWeight={'bold'}>
                {_('Pasos para tomar muestras en el lote y estimar el rendimiento:')}
            </Typography>
            <Stack spacing={1}>
                {content.map(({ title, items }, index) => (
                    <Stack key={index}>
                        <Typography color={'primary'} variant='body2' fontWeight={'bold'}>
                            {title}
                        </Typography>
                        <Box
                            component={'ul'}
                            sx={{
                                pl: 2,
                                '& li': {
                                    listStyleType: 'disc',
                                    fontSize: (t) => t.typography.body2.fontSize,
                                    color: (t) => t.palette.primary.main,
                                },
                            }}
                        >
                            {items.map((item) => (
                                <li>{item}</li>
                            ))}
                        </Box>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default YieldEstimationGuide;
